import React from 'react';
import { CardMedia } from '@material-ui/core';

import Img from 'retired/Img';

import { Opportunity } from '../types';

import { getCategoryIconData } from './getCategoryIconData';

export const OpportunityCardImage = ({ opportunity }: { opportunity: Opportunity }) => {
  const mainPicture = opportunity.pictures?.[0];
  if (mainPicture) {
    return <CardMedia style={{ height: 200 }} image={mainPicture} title={opportunity.name} />;
  }
  const fallbackIconData = getCategoryIconData(opportunity.categories || []);
  return (
    <div
      style={{
        width: '100%',
        height: 200,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: fallbackIconData.hexCode,
      }}
    >
      <Img src={fallbackIconData.icon} width={60} alt={opportunity.name} />
    </div>
  );
};
